import React from 'react';

function Svg({ size, children }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0 }}
    >
      {children}
    </svg>
  );
}

export function RoomIcon({ type, size = 22 }) {
  const sw = 1.6;
  switch (type) {
    case 'living': return (
      <Svg size={size}>
        {/* sofa back */}
        <rect x="2" y="7" width="20" height="5" rx="1.5" stroke="currentColor" strokeWidth={sw}/>
        {/* sofa seat */}
        <rect x="4" y="12" width="16" height="6" rx="1" stroke="currentColor" strokeWidth={sw}/>
        {/* left armrest */}
        <rect x="1" y="10" width="3" height="8" rx="1" stroke="currentColor" strokeWidth={sw}/>
        {/* right armrest */}
        <rect x="20" y="10" width="3" height="8" rx="1" stroke="currentColor" strokeWidth={sw}/>
        {/* legs */}
        <line x1="5.5" y1="18" x2="5.5" y2="21" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
        <line x1="18.5" y1="18" x2="18.5" y2="21" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
      </Svg>
    );
    case 'kitchen': return (
      <Svg size={size}>
        <rect x="2" y="2" width="20" height="20" rx="2" stroke="currentColor" strokeWidth={sw}/>
        <circle cx="7.5" cy="8" r="2.5" stroke="currentColor" strokeWidth={sw}/>
        <circle cx="16.5" cy="8" r="2.5" stroke="currentColor" strokeWidth={sw}/>
        <circle cx="7.5" cy="16.5" r="2.5" stroke="currentColor" strokeWidth={sw}/>
        <circle cx="16.5" cy="16.5" r="2.5" stroke="currentColor" strokeWidth={sw}/>
        <circle cx="7.5" cy="8" r="0.7" fill="currentColor"/>
        <circle cx="16.5" cy="8" r="0.7" fill="currentColor"/>
        <circle cx="7.5" cy="16.5" r="0.7" fill="currentColor"/>
        <circle cx="16.5" cy="16.5" r="0.7" fill="currentColor"/>
      </Svg>
    );
    case 'bedroom': return (
      <Svg size={size}>
        <rect x="2" y="4" width="20" height="17" rx="2" stroke="currentColor" strokeWidth={sw}/>
        <line x1="2" y1="9" x2="22" y2="9" stroke="currentColor" strokeWidth={sw}/>
        {/* pillows */}
        <rect x="4" y="5.5" width="6" height="3" rx="1" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="14" y="5.5" width="6" height="3" rx="1" stroke="currentColor" strokeWidth="1.2"/>
        {/* blanket fold */}
        <line x1="2" y1="17" x2="22" y2="17" stroke="currentColor" strokeWidth="1" strokeDasharray="3 2"/>
      </Svg>
    );
    case 'bathroom': return (
      <Svg size={size}>
        <rect x="2" y="9" width="20" height="12" rx="5" stroke="currentColor" strokeWidth={sw}/>
        <circle cx="12" cy="16" r="1.5" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="20" y="11" width="2" height="7" rx="1" fill="currentColor"/>
        <path d="M3.5 9 L3.5 6 Q3.5 4 5.5 4 L8 4" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" fill="none"/>
      </Svg>
    );
    case 'hallway': return (
      <Svg size={size}>
        <line x1="4" y1="22" x2="4" y2="2" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
        <line x1="16" y1="22" x2="16" y2="2" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
        <line x1="4" y1="2" x2="16" y2="2" stroke="currentColor" strokeWidth={sw}/>
        <line x1="2" y1="22" x2="22" y2="22" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
        {/* door swing arc */}
        <path d="M4 22 A18 18 0 0 1 22 4" stroke="currentColor" strokeWidth={sw} fill="none" strokeLinecap="round"/>
        <circle cx="14" cy="14" r="1.2" fill="currentColor"/>
      </Svg>
    );
    case 'garage': return (
      <Svg size={size}>
        <path d="M1 11 L12 3 L23 11" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        <rect x="2" y="10" width="20" height="12" rx="0.5" stroke="currentColor" strokeWidth={sw}/>
        <rect x="5" y="13" width="14" height="8" stroke="currentColor" strokeWidth="1.3"/>
        <line x1="5" y1="17.5" x2="19" y2="17.5" stroke="currentColor" strokeWidth="1"/>
        <rect x="10" y="20.5" width="4" height="1.2" rx="0.6" fill="currentColor"/>
      </Svg>
    );
    case 'office': return (
      <Svg size={size}>
        <rect x="4" y="2" width="16" height="11" rx="1.5" stroke="currentColor" strokeWidth={sw}/>
        <rect x="6" y="4" width="12" height="7" rx="0.5" fill="currentColor" fillOpacity="0.12"/>
        <line x1="12" y1="13" x2="12" y2="16" stroke="currentColor" strokeWidth={sw}/>
        <line x1="9" y1="16" x2="15" y2="16" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
        <rect x="1" y="16" width="22" height="4" rx="1.5" stroke="currentColor" strokeWidth={sw}/>
        <rect x="7" y="18" width="10" height="1.5" rx="0.5" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
      </Svg>
    );
    case 'dining': return (
      <Svg size={size}>
        <ellipse cx="12" cy="12" rx="6.5" ry="5.5" stroke="currentColor" strokeWidth={sw}/>
        {/* chairs */}
        <rect x="9" y="1" width="6" height="3" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="9" y="20" width="6" height="3" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="1" y="9.5" width="3" height="5" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="20" y="9.5" width="3" height="5" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
      </Svg>
    );
    default: return (
      <Svg size={size}>
        <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth={sw}/>
      </Svg>
    );
  }
}

export function FurniturePaletteIcon({ type, size = 18 }) {
  const sw = 1.5;
  switch (type) {
    case 'sofa': return (
      <Svg size={size}>
        <rect x="2" y="8" width="20" height="5" rx="1.5" stroke="currentColor" strokeWidth={sw}/>
        <rect x="4" y="13" width="16" height="5" rx="1" stroke="currentColor" strokeWidth={sw}/>
        <rect x="1" y="11" width="3" height="7" rx="1" stroke="currentColor" strokeWidth={sw}/>
        <rect x="20" y="11" width="3" height="7" rx="1" stroke="currentColor" strokeWidth={sw}/>
      </Svg>
    );
    case 'armchair': return (
      <Svg size={size}>
        <rect x="5" y="10" width="14" height="8" rx="1.5" stroke="currentColor" strokeWidth={sw}/>
        <rect x="3" y="12" width="3" height="6" rx="1" stroke="currentColor" strokeWidth={sw}/>
        <rect x="18" y="12" width="3" height="6" rx="1" stroke="currentColor" strokeWidth={sw}/>
        <rect x="5" y="7" width="14" height="4" rx="1" stroke="currentColor" strokeWidth={sw}/>
      </Svg>
    );
    case 'table': return (
      <Svg size={size}>
        <ellipse cx="12" cy="12" rx="9" ry="7" stroke="currentColor" strokeWidth={sw}/>
        <line x1="4" y1="8.5" x2="20" y2="8.5" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
        <line x1="4" y1="15.5" x2="20" y2="15.5" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
      </Svg>
    );
    case 'chair': return (
      <Svg size={size}>
        <rect x="5" y="10" width="14" height="9" rx="2" stroke="currentColor" strokeWidth={sw}/>
        <rect x="5" y="4" width="14" height="7" rx="1.5" stroke="currentColor" strokeWidth={sw}/>
        <line x1="7" y1="19" x2="7" y2="22" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
        <line x1="17" y1="19" x2="17" y2="22" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
      </Svg>
    );
    case 'bed': return (
      <Svg size={size}>
        <rect x="2" y="5" width="20" height="15" rx="2" stroke="currentColor" strokeWidth={sw}/>
        <line x1="2" y1="10" x2="22" y2="10" stroke="currentColor" strokeWidth={sw}/>
        <rect x="4" y="6" width="6" height="3.5" rx="1" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="14" y="6" width="6" height="3.5" rx="1" stroke="currentColor" strokeWidth="1.2"/>
      </Svg>
    );
    case 'desk': return (
      <Svg size={size}>
        <rect x="1" y="7" width="22" height="10" rx="1.5" stroke="currentColor" strokeWidth={sw}/>
        <line x1="7" y1="7" x2="7" y2="17" stroke="currentColor" strokeWidth={sw}/>
        <rect x="9" y="9" width="11" height="6" rx="1" stroke="currentColor" strokeWidth="1.2"/>
      </Svg>
    );
    case 'tv': return (
      <Svg size={size}>
        <rect x="1" y="4" width="22" height="13" rx="1.5" stroke="currentColor" strokeWidth={sw}/>
        <rect x="3" y="6" width="18" height="9" rx="0.5" fill="currentColor" fillOpacity="0.12"/>
        <path d="M9 17 L9 20 L15 20 L15 17" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        <line x1="7" y1="20" x2="17" y2="20" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
      </Svg>
    );
    case 'shelf': return (
      <Svg size={size}>
        <rect x="2" y="2" width="20" height="20" rx="1" stroke="currentColor" strokeWidth={sw}/>
        <line x1="2" y1="8.5" x2="22" y2="8.5" stroke="currentColor" strokeWidth={sw}/>
        <line x1="2" y1="15" x2="22" y2="15" stroke="currentColor" strokeWidth={sw}/>
        <line x1="9" y1="2" x2="9" y2="22" stroke="currentColor" strokeWidth="1.1"/>
        <line x1="16" y1="2" x2="16" y2="22" stroke="currentColor" strokeWidth="1.1"/>
      </Svg>
    );
    case 'wardrobe': return (
      <Svg size={size}>
        <rect x="2" y="1" width="20" height="22" rx="1" stroke="currentColor" strokeWidth={sw}/>
        <line x1="12" y1="1" x2="12" y2="23" stroke="currentColor" strokeWidth={sw}/>
        <circle cx="10.5" cy="12" r="1" fill="currentColor"/>
        <circle cx="13.5" cy="12" r="1" fill="currentColor"/>
      </Svg>
    );
    case 'bathtub': return (
      <Svg size={size}>
        <rect x="2" y="9" width="20" height="12" rx="5" stroke="currentColor" strokeWidth={sw}/>
        <circle cx="12" cy="16" r="1.5" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="20" y="11" width="2" height="7" rx="1" fill="currentColor"/>
        <path d="M3.5 9 L3.5 6 Q3.5 4 5.5 4 L8 4" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" fill="none"/>
      </Svg>
    );
    case 'toilet': return (
      <Svg size={size}>
        <rect x="7" y="1" width="10" height="7" rx="1" stroke="currentColor" strokeWidth={sw}/>
        <path d="M5 8 Q4 22 12 22 Q20 22 19 8 Z" stroke="currentColor" strokeWidth={sw} fill="none"/>
        <line x1="5" y1="8" x2="19" y2="8" stroke="currentColor" strokeWidth={sw}/>
      </Svg>
    );
    case 'sink': return (
      <Svg size={size}>
        <rect x="3" y="5" width="18" height="15" rx="3" stroke="currentColor" strokeWidth={sw}/>
        <rect x="6" y="8" width="12" height="9" rx="2" stroke="currentColor" strokeWidth="1.2"/>
        <circle cx="12" cy="12.5" r="1.5" fill="currentColor"/>
        <rect x="10" y="5" width="4" height="3" rx="0.5" fill="currentColor" fillOpacity="0.4"/>
      </Svg>
    );
    case 'lamp': return (
      <Svg size={size}>
        <path d="M6 10 L18 10 L15 3 L9 3 Z" stroke="currentColor" strokeWidth={sw} strokeLinejoin="round" fill="none"/>
        <line x1="12" y1="10" x2="12" y2="20" stroke="currentColor" strokeWidth={sw}/>
        <ellipse cx="12" cy="21" rx="4" ry="1.5" stroke="currentColor" strokeWidth={sw}/>
      </Svg>
    );
    case 'plant': return (
      <Svg size={size}>
        <path d="M8 16 L16 16 L15 22 L9 22 Z" stroke="currentColor" strokeWidth={sw} strokeLinejoin="round" fill="none"/>
        <line x1="7" y1="16" x2="17" y2="16" stroke="currentColor" strokeWidth={sw}/>
        <line x1="12" y1="16" x2="12" y2="10" stroke="currentColor" strokeWidth={sw}/>
        <path d="M12 12 C10 10 6 9 5 11 C7 11 10 12 12 12 Z" fill="currentColor" fillOpacity="0.85"/>
        <path d="M12 14 C14 11 18 10 19 12 C17 12 14 13 12 14 Z" fill="currentColor" fillOpacity="0.85"/>
        <path d="M11 10 C11 7 13 5 13 8 C13 9 12 10 11 10 Z" fill="currentColor" fillOpacity="0.7"/>
      </Svg>
    );
    case 'rug': return (
      <Svg size={size}>
        <rect x="2" y="5" width="20" height="14" rx="1.5" stroke="currentColor" strokeWidth={sw}/>
        <rect x="5" y="8" width="14" height="8" rx="0.5" stroke="currentColor" strokeWidth="1"/>
        <ellipse cx="12" cy="12" rx="3" ry="2" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
      </Svg>
    );
    default: return (
      <Svg size={size}>
        <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth={sw}/>
      </Svg>
    );
  }
}

export function DoorIcon({ size = 16 }) {
  const sw = 1.6;
  return (
    <Svg size={size}>
      <line x1="2" y1="22" x2="22" y2="22" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
      <line x1="4" y1="22" x2="4" y2="3" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
      <line x1="20" y1="22" x2="20" y2="3" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
      <line x1="4" y1="3" x2="20" y2="3" stroke="currentColor" strokeWidth={sw}/>
      <circle cx="15.5" cy="12.5" r="1.3" fill="currentColor"/>
      <path d="M4 22 A16 16 0 0 1 20 6" stroke="currentColor" strokeWidth="1" strokeDasharray="2.5 2" strokeLinecap="round" opacity="0.5"/>
    </Svg>
  );
}

export function WindowIcon({ size = 16 }) {
  const sw = 1.6;
  return (
    <Svg size={size}>
      <rect x="2" y="5" width="20" height="14" rx="1" stroke="currentColor" strokeWidth={sw}/>
      <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth={sw}/>
      <line x1="2" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth={sw}/>
      <line x1="1" y1="19" x2="23" y2="19" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.55"/>
    </Svg>
  );
}

export function ArchIcon({ size = 16 }) {
  const sw = 1.6;
  return (
    <Svg size={size}>
      <path d="M4 22 L4 11 A8 8 0 0 1 20 11 L20 22" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="2" y1="22" x2="22" y2="22" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
      <line x1="12" y1="3" x2="12" y2="6.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.55"/>
    </Svg>
  );
}

export function PaintingIcon({ size = 16 }) {
  const sw = 1.6;
  return (
    <Svg size={size}>
      <rect x="2" y="3" width="20" height="16" rx="1" stroke="currentColor" strokeWidth={sw}/>
      <circle cx="8" cy="9" r="2" stroke="currentColor" strokeWidth="1.3"/>
      <path d="M4 16 L9 11 L13 14.5 L16 12 L20 16" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      <line x1="8" y1="19" x2="8" y2="22" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.55"/>
      <line x1="16" y1="19" x2="16" y2="22" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.55"/>
    </Svg>
  );
}

export function AcIcon({ size = 16 }) {
  const sw = 1.6;
  return (
    <Svg size={size}>
      <rect x="1.5" y="6" width="21" height="8" rx="2.5" stroke="currentColor" strokeWidth={sw}/>
      <line x1="4" y1="9" x2="17" y2="9" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
      <line x1="4" y1="11" x2="17" y2="11" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
      <circle cx="19.5" cy="10" r="1" fill="currentColor"/>
      <path d="M6 14 Q6 18 9 19.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" fill="none" opacity="0.7"/>
      <path d="M13 14 Q13 19 17 20.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" fill="none" opacity="0.7"/>
    </Svg>
  );
}

export function ClockIcon({ size = 16 }) {
  const sw = 1.6;
  return (
    <Svg size={size}>
      <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeWidth={sw}/>
      <line x1="12" y1="12" x2="12" y2="6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="12" y1="12" x2="16" y2="14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="12" cy="12" r="1.1" fill="currentColor"/>
    </Svg>
  );
}

export function OutletIcon({ size = 16 }) {
  const sw = 1.6;
  return (
    <Svg size={size}>
      <rect x="4" y="2" width="16" height="20" rx="2.5" stroke="currentColor" strokeWidth={sw}/>
      <rect x="8" y="7" width="1.8" height="4.5" rx="0.7" fill="currentColor"/>
      <rect x="14.2" y="7" width="1.8" height="4.5" rx="0.7" fill="currentColor"/>
      <circle cx="12" cy="15.5" r="1.3" stroke="currentColor" strokeWidth="1.2"/>
    </Svg>
  );
}

export function RadiatorIcon({ size = 16 }) {
  const sw = 1.6;
  return (
    <Svg size={size}>
      <rect x="2" y="5" width="20" height="13" rx="1.5" stroke="currentColor" strokeWidth={sw}/>
      <line x1="6" y1="5" x2="6" y2="18" stroke="currentColor" strokeWidth="1.2" opacity="0.6"/>
      <line x1="10" y1="5" x2="10" y2="18" stroke="currentColor" strokeWidth="1.2" opacity="0.6"/>
      <line x1="14" y1="5" x2="14" y2="18" stroke="currentColor" strokeWidth="1.2" opacity="0.6"/>
      <line x1="18" y1="5" x2="18" y2="18" stroke="currentColor" strokeWidth="1.2" opacity="0.6"/>
      <line x1="4" y1="20.5" x2="4" y2="22" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
      <line x1="20" y1="20.5" x2="20" y2="22" stroke="currentColor" strokeWidth={sw} strokeLinecap="round"/>
    </Svg>
  );
}
